import React from 'react';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';

import { Divider } from 'components/common/Divider/Divider';
import { mapRangeToSliderValue } from 'components/common/Slider/Slider';

const PERCENTAGE_MULTIPLIER = 100;

type ValuationTickProps = {
  currentValuation: number;
  multiplier: number;
  minMultiplier: number;
  maxMultiplier: number;
};
export function ValuationTick(props: ValuationTickProps): JSX.Element {
  const { currentValuation, multiplier, minMultiplier, maxMultiplier } = props;
  return (
    <div
      className="valuation-tick"
      style={{
        left: `${mapRangeToSliderValue(multiplier, minMultiplier, maxMultiplier) * PERCENTAGE_MULTIPLIER}%`,
      }}
    >
      <Divider className="tick-line" orientation="vertical" />
      <div className="valuation-tick-label">
        <Typography variant="body">${currentValuation * multiplier}B</Typography>
      </div>
    </div>
  );
}
